import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../Helpers/Handler";
import { textCapitalize } from "../../Helpers/Utils";
import Select from "react-select";


const DepartmentFormModal = ({ mode = "create", department, onClose, onSaved }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [departmentName, setDepartmentName] = useState(department?.departmentName || "");
    const [description, setDescription] = useState(department?.description || "");
    const [taskTypes, setTaskTypes] = useState(department?.taskTypes || []);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const taskTypeOptions = [
        { value: "pickup", label: "Pickup" },
        { value: "delivery", label: "Delivery" },
    ];


    const onSubmit = async () => {
        const name = departmentName.trim();
        if (name.length < 2) {
            toast.error("Department name must be at least 2 characters");
            return;
        }

        setSaving(true);
        const response = mode === "edit"
            ? await Handler({ method: "patch", url: `/admin/staff/department/${department.departmentId}`, data: { departmentName: name, taskTypes } })
            : await Handler({ method: "post", url: "/admin/staff/department/register", data: { departmentName: name, ...(description.trim() ? { description: description.trim() } : {}), taskTypes } });

        if (response?.success) {
            toast.success(response?.data?.message || (mode === "edit" ? "Department updated" : "Department created"));
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to save the department"));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">{mode === "edit" ? "Edit Department" : "Add Department"}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label">Department name</label>
                                <input type="text" className="form-control" value={departmentName} onChange={(e) => setDepartmentName(e.target.value)} placeholder="e.g. Fleet Operations" />
                            </div>

                            <div className="col-12">
                                <label className="form-label">
                                    Task types <span className="text-muted">(optional)</span>
                                </label>

                                <Select
                                    isMulti
                                    options={taskTypeOptions}
                                    value={taskTypeOptions.filter((option) =>
                                        taskTypes.includes(option.value)
                                    )}
                                    onChange={(selectedOptions) => {
                                        setTaskTypes(
                                            selectedOptions
                                                ? selectedOptions.map((option) => option.value)
                                                : []
                                        );
                                    }}
                                    placeholder="Select task types..."
                                    closeMenuOnSelect={false}
                                    isClearable
                                    classNamePrefix="task-select"
                                />

                                <div className="form-text">
                                    Select the tasks staff in this department can be assigned.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={saving}>
                            {saving ? "Saving..." : mode === "edit" ? "Save changes" : "Create department"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepartmentFormModal;
